module.exports = __webpack_public_path__ + "img/category-fishing-game.b8dd16cd.png";